import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCheckmarkIconSecondary from './svgs/CheckmarkIconSecondary.js';
import SvgCheckmarkIcon from './svgs/CheckmarkIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var CheckmarkIcon = (props => useIcon(SvgCheckmarkIcon, SvgCheckmarkIconSecondary, props));

export { CheckmarkIcon as default };
